module.exports = (__webpack_require__(0))(28);


//////////////////
// WEBPACK FOOTER
// delegated ./src/models/FolderModel.js from dll-reference girder_lib
// module id = 10
// module chunks = 0